const STORAGE_KEY = "quote_cart";

/* ==========================================
   GET QUOTE CART
========================================== */

function getQuoteCart() {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (error) {
        console.error("Error reading quote cart:", error);
        return [];
    }
}


/* ==========================================
   SAVE QUOTE CART
========================================== */

function saveQuoteCart(cart) {

    localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(cart)
    );

    // Automatically update header count
    updateQuoteCartCount();
}


/* ==========================================
   UPDATE HEADER QUOTE COUNT
========================================== */

function updateQuoteCartCount() {

    const countElement =
        document.getElementById("quote-cart-count");

    if (!countElement) return;

    const cart = getQuoteCart();

    // Calculate total quantity
    const totalQty = cart.reduce((total, item) => {

        return total + Number(item.qty || 0);

    }, 0);

    countElement.textContent = totalQty;

    // Hide badge if empty
    if (totalQty <= 0) {

        countElement.classList.add("is-empty");

    } else {

        countElement.classList.remove("is-empty");

    }
}


/* ==========================================
   ADD PRODUCT TO QUOTE
========================================== */

document.addEventListener("click", function (e) {

    const button = e.target.closest(".add-to-quote");

    if (!button) return;

    e.preventDefault();

    const variantId = button.dataset.variantId;

    if (!variantId) {

        console.error("Variant ID is missing.");

        alert("Unable to add this product to the quote.");

        return;
    }

    const cart = getQuoteCart();

    const product = {

        product_id: button.dataset.productId || "",

        variant_id: variantId,

        title: button.dataset.title || "Product",

        image: button.dataset.image || "",

        qty: 1

    };


    // Check if product already exists
    const exists = cart.find(function (item) {

        return String(item.variant_id) ===
            String(product.variant_id);

    });


    // Increase quantity if already added
    if (exists) {

        exists.qty = Number(exists.qty) + 1;

    } else {

        cart.push(product);

    }


    // Save cart
    // Header count updates automatically
    saveQuoteCart(cart);


    /* ------------------------------------------
       BUTTON SUCCESS STATE
    ------------------------------------------ */

    const originalText = "Add to Quote";

    button.classList.add("added");

    button.innerHTML = "✓ Added to Quote";


    /* ------------------------------------------
       REMOVE OLD SUCCESS MESSAGE
    ------------------------------------------ */

    const parent = button.parentElement;

    if (parent) {

        const oldMessage =
            parent.querySelector(".quote-success");

        if (oldMessage) {

            oldMessage.remove();

        }

    }


    /* ------------------------------------------
       CREATE SUCCESS MESSAGE
    ------------------------------------------ */

    const success = document.createElement("div");

    success.className = "quote-success";

    success.innerHTML = `
        <span>✓ Product added to your quote.</span>

        <a href="/pages/quote-page">
            View Quote
        </a>
    `;


    // Insert message below button
    button.insertAdjacentElement(
        "afterend",
        success
    );


    /* ------------------------------------------
       RESET BUTTON AFTER 5 SECONDS
    ------------------------------------------ */

    setTimeout(function () {

        button.classList.remove("added");

        button.innerHTML = originalText;

        if (success && success.parentNode) {

            success.remove();

        }

    }, 5000);


    console.log("Quote Cart:", cart);

});


/* ==========================================
   RENDER QUOTE CART
========================================== */

function renderQuote() {

    const container =
        document.getElementById("quote-items");

    if (!container) return;

    const cart = getQuoteCart();


    /* ------------------------------------------
       EMPTY QUOTE CART
    ------------------------------------------ */

    if (cart.length === 0) {

        container.innerHTML = `
            <div class="quote-empty">

                <h3>Your quote cart is empty.</h3>

                <a href="/collections/all">
                    Continue Shopping
                </a>

            </div>
        `;

        return;

    }


    /* ------------------------------------------
       PRODUCT LIST
    ------------------------------------------ */

    let html = "";


    cart.forEach(function (item, index) {

        html += `

            <div class="quote-item">

                <div class="quote-image">

                    <img
                        src="${item.image}"
                        alt="${escapeHtml(item.title)}"
                    >

                </div>


                <div class="quote-content">

                    <h3>
                        ${escapeHtml(item.title)}
                    </h3>


                    <div class="quote-quantity-wrap">

                        <label>
                            Quantity
                        </label>

                        <input
                            type="number"
                            min="1"
                            value="${Number(item.qty)}"
                            class="quote-qty"
                            data-index="${index}"
                        >

                    </div>


                    <button
                        type="button"
                        class="remove-item"
                        data-index="${index}"
                    >
                        Remove
                    </button>

                </div>

            </div>

        `;

    });


    container.innerHTML = html;

}


/* ==========================================
   ESCAPE HTML
   Prevents product titles from breaking HTML
========================================== */

function escapeHtml(value) {

    const div = document.createElement("div");

    div.textContent = value || "";

    return div.innerHTML;

}


/* ==========================================
   UPDATE PRODUCT QUANTITY
========================================== */

document.addEventListener("change", function (e) {

    const quantityInput =
        e.target.closest(".quote-qty");

    if (!quantityInput) return;


    const index =
        Number(quantityInput.dataset.index);


    let quantity =
        parseInt(quantityInput.value, 10);


    // Minimum quantity = 1
    if (!quantity || quantity < 1) {

        quantity = 1;

        quantityInput.value = 1;

    }


    const cart = getQuoteCart();


    // Check item exists
    if (!cart[index]) return;


    // Update quantity
    cart[index].qty = quantity;


    // Save cart
    // Header count automatically updates
    saveQuoteCart(cart);


    // Re-render quote cart
    renderQuote();

});


/* ==========================================
   REMOVE PRODUCT FROM QUOTE
========================================== */

document.addEventListener("click", function (e) {

    const removeButton =
        e.target.closest(".remove-item");

    if (!removeButton) return;


    const index =
        Number(removeButton.dataset.index);


    const cart = getQuoteCart();


    // Check valid index
    if (
        index < 0 ||
        index >= cart.length
    ) {

        return;

    }


    // Remove product
    cart.splice(index, 1);


    // Save cart
    // Header count automatically updates
    saveQuoteCart(cart);


    // Re-render quote cart
    renderQuote();

});


/* ==========================================
   QUOTE FORM SUBMISSION
========================================== */

function initializeQuoteForm() {

    const quoteForm =
        document.getElementById("quote-form");

    if (!quoteForm) return;


    quoteForm.addEventListener(
        "submit",
        function (e) {

            e.preventDefault();


            const cart =
                getQuoteCart();


            /* ------------------------------------------
               CHECK IF CART IS EMPTY
            ------------------------------------------ */

            if (cart.length === 0) {

                alert(
                    "Please add at least one product to your quote."
                );

                return;

            }


            /* ------------------------------------------
               GET FORM DATA
            ------------------------------------------ */

            const formData =
                new FormData(quoteForm);


            const customer =
                Object.fromEntries(formData.entries());


            const payload = {

                customer: customer,

                products: cart

            };


            console.log(
                "Quote Submission:",
                payload
            );


            /* ------------------------------------------
               SUBMIT TO BACKEND
            ------------------------------------------ */

            fetch("/apps/request-quote", {

                method: "POST",

                headers: {

                    "Content-Type":
                        "application/json"

                },

                body:
                    JSON.stringify(payload)

            })

            .then(function (response) {

                if (!response.ok) {

                    throw new Error(
                        "Quote submission failed."
                    );

                }

                return response.json();

            })

            .then(function (data) {

                console.log(
                    "Quote submitted:",
                    data
                );


                alert(
                    "Quote Submitted Successfully."
                );


                // Clear quote cart
                localStorage.removeItem(
                    STORAGE_KEY
                );


                // Update header count
                updateQuoteCartCount();


                // Re-render quote cart
                renderQuote();


                // Reset form
                quoteForm.reset();

            })

            .catch(function (error) {

                console.error(
                    "Quote Error:",
                    error
                );

                alert(
                    "Something went wrong. Please try again."
                );

            });

        }

    );

}


/* ==========================================
   INITIALIZE EVERYTHING
========================================== */

document.addEventListener(
    "DOMContentLoaded",
    function () {

        // Show correct count on page load
        updateQuoteCartCount();

        // Render quote page products
        renderQuote();

        // Initialize quote form
        initializeQuoteForm();

    }
);